import Button from "../ui/button";
import {useModal} from "../components/ModalProvider";
import {ModalHeader, ModalContent, ModalFooter} from "../ui/modal";

type Props = {
  title: string;
  message: string;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  size?: "s" | "m" | "l" | "xl";
};

export function useConfirmModal({title, message, onConfirm, confirmText, cancelText, size}: Props) {
  const {add} = useModal();

  const open = () => {
    const modal = add({
      size,
      header: <ModalHeader>{title}</ModalHeader>,
      content: (
        <ModalContent>
          <p>{message}</p>
        </ModalContent>
      ),
      footer: (
        <ModalFooter style={{display: "flex", justifyContent: "flex-end", gap: 8}}>
          <Button variant="outlined" color="danger" onClick={() => modal.remove()}>
            {cancelText}
          </Button>
          <Button
            variant="filled"
            color="success"
            onClick={() => {
              onConfirm();
              modal.remove();
            }}
          >
            {confirmText}
          </Button>
        </ModalFooter>
      ),
    });
  };

  return {open};
}
